import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDownRightIcon } from 'lucide-react';
import { credentials } from '../data/practice';
const rise = {
  hidden: {
    opacity: 0,
    y: 14
  },
  show: {
    opacity: 1,
    y: 0
  }
};
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section id="top" className="border-b border-rule" data-id="element-31" data-mp="4m8l89fgoljc">
      <motion.div initial="hidden" animate="show" transition={{
      staggerChildren: 0.05
    }} className="mx-auto max-w-page px-6 pb-16 pt-16 lg:px-10 lg:pb-24 lg:pt-24" data-id="element-32" data-mp="4jm5vnmbx1qk">
        <motion.p variants={rise} transition={{
        duration: 0.3,
        ease
      }} className="font-sans text-[12px] uppercase tracking-overline text-muted" data-id="element-33" data-mp="x8jmlmaw6qh7">
          Bengaluru, India — Financial Advisor &amp; Founder
        </motion.p>

        <motion.h1 variants={rise} transition={{
        duration: 0.3,
        ease
      }} className="mt-8 max-w-[19ch] font-serif text-[clamp(2.6rem,7vw,6rem)] leading-[0.95] tracking-[-0.02em] text-ink" data-id="element-34" data-mp="3d2birmcv0tty">
          I build ventures, and look after the{' '}
          <span className="italic text-accent" data-id="element-35" data-mp="3o7vktmez1ryc">wealth they create.</span>
        </motion.h1>

        <motion.div variants={rise} transition={{
        duration: 0.3,
        ease
      }} className="mt-12 grid gap-10 border-t border-rule pt-10 lg:grid-cols-12" data-id="element-36" data-mp="39b4hx3639y3z">
          <ul className="flex flex-col gap-2 lg:col-span-4" data-id="element-37" data-mp="30iawsp3yo4i7">
            {credentials.slice(0, 3).map(credential => <li key={credential} className="font-sans text-[13px] text-ink-soft" data-id="element-38" data-mp="359t0hkxdcj6v">
                {credential}
              </li>)}
          </ul>

          <div className="lg:col-span-7 lg:col-start-6" data-id="element-39" data-mp="2viy3blil3z6n">
            <p className="font-sans text-[17px] leading-[1.65] text-ink-soft" data-id="element-40" data-mp="2vjg5szvub9n0">
              A value identifier, creator and connector. Over fifteen years I have started
              companies across investment advisory, venture building, co-working, food and
              e-commerce — in Chennai, Bengaluru, Barcelona and Gothenburg. Today my day job is
              advice: I am a SEBI Registered Investment Advisor and Certified Financial Planner,
              helping clients with financial, investment, estate and tax planning.
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-3" data-id="element-41" data-mp="ddf0m3gnfa5l">
              <a href="#contact" className="group inline-flex items-center gap-2 border-b border-ink pb-1 font-sans text-[15px] font-medium text-ink transition-colors duration-150 ease-out hover:border-accent hover:text-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-4 focus-visible:ring-offset-paper" data-id="element-42" data-mp="dbasf9bpvozi">
                Start a conversation
                <ArrowDownRightIcon aria-hidden="true" className="h-4 w-4 transition-transform duration-200 ease-expo group-hover:translate-x-0.5 group-hover:translate-y-0.5" data-id="element-43" data-mp="3lu081ftmtv6l" />
              </a>
              <span className="font-sans text-[13px] text-muted" data-id="element-44" data-mp="1x7hw9eyk651e">
                Advisory, Partnerships, Speaker Engagements
              </span>
            </div>
          </div>
        </motion.div>
      </motion.div>
    </section>;
}